import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';

export function filterBayerRolesFromKeycloak(roles: string[]): string[] {
    const currentRoles = Object.values(KeycloakApplicationRolesEnum).map(item => item.toString().toLowerCase());
    return roles.filter(element => currentRoles.includes(element));
}

export function filterEffectiveBayerRolesFromKeycloak(roles: string[]): string[] {
    const bayerRoles = filterBayerRolesFromKeycloak(roles);
    return bayerRoles.filter(element => element !== KeycloakApplicationRolesEnum.USER.toLowerCase());
}

export function multipleRolesPresent(roles: string[]): boolean {
    const effectiveRoles = filterEffectiveBayerRolesFromKeycloak(roles);
    return effectiveRoles.length > 1;
}
